import React, {useEffect, useRef, useState} from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import ProgressBar from 'components/ProgressBar'
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import SingleButton from "../components/SingleButton";
import UploadService from "services/UploadService";
import DemandOffersService from "../../../services/DemandOffersService";
import isResponseValid from "../../../libs/isResponseValid";
import {ContractorPasswordState} from "../../../constants/ContractorPasswordState";
import {useParams} from "react-router";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    item: {
        alignSelf: "end"
    }
}))

function UploadFilePopup(
    {
        downloadFiles,
        handleSubmit,
        onUpload,
        encryptRoundId
    }) {

    const errorTranslate = Tr('file_response')
    const setRefresh = useState(0)[1];
    const filesStatus = useRef();
    const uploadedFiles = useRef([]);
    const params = useParams();
    const classes = useStyle();
    const [dialogClosed, setDialogClosed] = useState(false);

    useEffect(() => {
        if (encryptRoundId) {
            DemandOffersService.getPasswordStatus(params.id, params.stageId)
                .then((resp) => {
                    if (isResponseValid(resp, onError)) {
                        if (resp.result.state === ContractorPasswordState.HAS_PASSWORD_STORED) {
                            doUpload();
                        } else {
                            DemandOffersService.openContractorPasswordPopup(doUpload, onError)
                        }
                    } else {
                        onError(resp)
                    }
                })
                .catch(onError);
        } else {
            doUpload();
        }
        // eslint-disable-next-line
    }, [])

    const onError = (e) => {
        console.error("CheckPassword error", e)
        handleSubmit({
            files: [],
            config: downloadFiles.config
        })
    }

    const doUpload = () => {
        filesStatus.current = downloadFiles.files.map((element) => ({
            loaded: 0,
            total: 1,
            name: element.name,
            uploadStatus: null,
        }));

        downloadFiles.files.forEach((element, index) => {
            UploadService.upload(element, handleUploadProgressChange(element, index), null, encryptRoundId)
                .then(res => {
                    filesStatus.current[index].uploadStatus = res.uploadStatus;
                    if (res.uploadStatus === 'OK') {
                        uploadSuccess({...res, originalIndex: index});
                    } else {
                        setRefresh(st => st + 1);
                    }
                })
                .catch((e) => {
                    console.error(e)
                    if (filesStatus.current[index]) {
                        filesStatus.current[index].uploadStatus = 'ERROR';
                    }
                    setRefresh(st => st + 1)
                })
        });
    }

    const uploadSuccess = (fileData) => {
        uploadedFiles.current.push(fileData);
        if (onUpload)
            onUpload(fileData);
        setRefresh(st => st + 1);
    };


    const handleUploadProgressChange = (element, index) => (e) => {
        filesStatus.current[index] = {
            loaded: e.loaded,
            total: e.total,
            name: element.name,
            uploadStatus: e.loaded === e.total ? "SCANNING_FILE" : null,
        };
        setRefresh(st => st + 1);
    };

    const checkFilesLoaded = () => {
        const loaded = filesStatus.current && uploadedFiles.current && filesStatus.current.every(e => e.loaded === e.total) &&
            filesStatus.current.filter((x) => ["SCANNING_FILE", "OK"].includes(x.uploadStatus)).length === uploadedFiles.current.length
        return loaded;
    };

    const handleClose = () => {
        setDialogClosed(true);
        handleSubmit({
            files: uploadedFiles.current,
            config: downloadFiles.config
        })
    }


    return (
        <Dialog
            title={Tr('file_upload')}
            open
            maxWidth={'md'}
            dialogActions={<SingleButton disabled={!checkFilesLoaded() || dialogClosed} onClick={handleClose} label={Tr('close')}/>}
        >
            {!!filesStatus.current && filesStatus.current.map(({loaded, total, name, uploadStatus}, i) => {
                return (
                    <React.Fragment key={i}>
                        <GridBlock justify='space-between' wrap="nowrap" itemClassName={classes.item}>
                            <Typography variant='body1'>
                                {name}
                            </Typography>
                            <Typography noWrap variant='body2' color={["SCANNING_FILE", "OK"].includes(uploadStatus)? undefined : "error"}>
                                {errorTranslate[uploadStatus]}
                            </Typography>
                        </GridBlock>
                        <ProgressBar
                            value={loaded}
                            max={total}
                        />
                        <br/>
                    </React.Fragment>
                )
            })}

        </Dialog>
    )
}

UploadFilePopup.propTypes = {
    classes: PropTypes.any,
}

export default UploadFilePopup;